import React, { useEffect, useId, useState } from 'react';
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { href: '#product', label: 'Product' },
  { href: '#features', label: 'Features' },
  { href: '#how-it-works', label: 'How it works' },
  { href: '#contact', label: 'Contact' },
] as const;

/**
 * Sticky marketing nav with section anchors and a primary Sign in CTA.
 */
const LandingNav: React.FC = () => {
  const [open, setOpen] = useState(false);
  const menuId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const close = () => setOpen(false);

  return (
    <header className="landing-nav">
      <div className="landing-nav__inner">
        <a href="#top" className="landing-brand" onClick={close}>
          <span className="landing-brand__mark" aria-hidden="true">
            <svg viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
              <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zm0 10a2 2 0 11-.001-3.999A2 2 0 0110 12z" />
            </svg>
          </span>
          <span className="landing-brand__text">Winery</span>
        </a>

        <nav className="landing-nav__desktop" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="landing-nav__link">
              {link.label}
            </a>
          ))}
        </nav>

        <div className="landing-nav__actions">
          <a href="#contact" className="landing-nav__ghost">
            Request access
          </a>
          <Link to="/login" className="landing-btn landing-btn--primary landing-btn--sm">
            Sign in
          </Link>
          <button
            type="button"
            className="landing-nav__menu-btn"
            aria-expanded={open}
            aria-controls={menuId}
            onClick={() => setOpen((v) => !v)}
          >
            <span className="sr-only">{open ? 'Close menu' : 'Open menu'}</span>
            <span aria-hidden="true">{open ? '✕' : '☰'}</span>
          </button>
        </div>
      </div>

      {open && (
        <nav id={menuId} className="landing-nav__mobile" aria-label="Mobile">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="landing-nav__mobile-link" onClick={close}>
              {link.label}
            </a>
          ))}
          <a href="#contact" className="landing-nav__mobile-link" onClick={close}>
            Request access
          </a>
          <Link to="/login" className="landing-btn landing-btn--primary" onClick={close}>
            Sign in
          </Link>
        </nav>
      )}
    </header>
  );
};

export default LandingNav;
